import React from 'react';
import { SkeletonBlock } from '../../../components/skeleton/skeleton';

// First-paint skeleton of the feed: the two-column row shape, three times.
const ReleaseNotesSkeleton = ({ rows = 3 }) => (
  <div className="divide-y divide-slate-200 dark:divide-slate-700" aria-hidden="true">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="grid gap-x-12 gap-y-6 py-8 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:py-10">
        <div className="space-y-3">
          <SkeletonBlock className="h-3 w-24" />
          <SkeletonBlock className="h-8 w-5/6" />
          <SkeletonBlock className="h-8 w-2/3" />
          <div className="flex items-center gap-3">
            <SkeletonBlock className="h-10 w-10 !rounded-full" />
            <SkeletonBlock className="h-4 w-28" />
          </div>
        </div>
        <div className="space-y-3">
          <SkeletonBlock className="aspect-video w-full !rounded-lg" />
          <SkeletonBlock className="h-4 w-full" />
          <SkeletonBlock className="h-4 w-11/12" />
        </div>
      </div>
    ))}
  </div>
);

export default ReleaseNotesSkeleton;
